import gql from "graphql-tag";

export const getInspectionDataQuery = gql`
  query GetInspectionData($tenantId: ID!, $taskId: ID!) {
    getInspectionData(tenantId: $tenantId, taskId: $taskId)
  }
`;
